import ShipmentCard from 'components/orders/ShipmentCard/ShipmentCard.styled';

export default ShipmentCard;
